import qs from 'qs';

export class EvaluationsClient {
  constructor(evaluationsBackend, authenticationService) {
    this.evaluationsBackend = evaluationsBackend;
    this.authenticationService = authenticationService;
  }

  async getEvaluationById(id) {
    const response = await this.evaluationsBackend.get(
      `/automatic-evaluation/evaluations/${id}`,
      this.defaultAxiosRequestConfig()
    );
    return this.formatData(response.data);
  }

  formatData(data) {
    const { evaluationDate } = data;
    const date = evaluationDate.split('T')[0];

    return {
      ...data,
      evaluationDate: date
    };
  }

  async getEvaluations(filter) {
    const response = await this.evaluationsBackend.get(
      '/automatic-evaluation/evaluations',
      { ...this.defaultAxiosRequestConfig(), ...filter }
    );
    return response.data;
  }

  async setAutomaticRatify(evaluationId) {
    const url = `/automatic-evaluation/ratify/${evaluationId}`;
    const config = this.defaultAxiosRequestConfig();
    const response = await this.evaluationsBackend.post(url, {}, config);
    return response.data;
  }

  async getEvaluationsByQuery(filter) {
    const response = await this.evaluationsBackend.get(
      '/automatic-evaluation/evaluations/q',
      { ...this.defaultAxiosRequestConfig(), ...filter }
    );

    return response.data || [];
  }

  getEvaluationsByDateAndExecutive(startDate, endDate, executiveEmail = -1, stage = 'none', number = 1, size = 10) {
    const date = {};
    date.start = new Date(startDate).toISOString();
    date.end = new Date(endDate).toISOString();
    const filter = {
      params: {
        filter: {
          date,
          stage
        },
        sort: '-evaluationDate'
      },
      paramsSerializer: this.paramsSerializer()
    };
    if (executiveEmail) {
      filter.params.filter.executiveEmail = executiveEmail;
    } else {
      filter.params.filter.executiveEmail = -1;
    }

    if (size || number) {
      filter.params.page = { size, number };
    }

    return this.getEvaluations(filter);
  }

  getEvaluationsBySearchString(searchString) {
    const filter = {
      params: {
        filter: {
          search: searchString
        }
      },
      paramsSerializer: this.paramsSerializer()
    };

    return this.getEvaluationsByQuery(filter);
  }

  paramsSerializer() {
    return params => { return qs.stringify(params); };
  }

  async saveEvaluation(data) {
    const response = await this.evaluationsBackend.post(
      '/v1.0/evaluation/evaluate',
      data,
      { ...this.defaultAxiosRequestConfig(), timeout: 300000 }
    );
    return this.formatSavedData(response.data);
  }

  formatSavedData(data) {
    const { data: { storeEvaluation } } = data;
    return storeEvaluation;
  }

  defaultAxiosRequestConfig() {
    return {
      headers: this.authenticationService.authHeader()
    };
  }
}
